import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import Home from './pages/Home'
import Analysis from './pages/Analysis'
import Portfolio from './pages/Portfolio'
import Positions from './pages/Positions'
import Trades from './pages/Trades'
import DataManagement from './pages/DataManagement'
import Settings from './pages/Settings'
import Watchers from './pages/Watchers'
import ModelDesk from './pages/ModelDesk'
import Watchlist from './pages/Watchlist'
import Discovery from './pages/Discovery'
import LogicGates from './pages/LogicGates'
import Performance from './pages/Performance'
import Testing from './pages/Testing'
import TradingMonitor from './pages/TradingMonitor'
import EdgeDiagnostics from './pages/EdgeDiagnostics'
import JoshSkills from './pages/JoshSkills'   // T-351: JoshSkills shadow trades + skill catalogue (read-only)
import Tools from './pages/Tools'   // T-381: Research > Tools (Midterms screener), read-only
import Login from './pages/Login'
import OAuthCallback from './pages/OAuthCallback'
import { SettingsProvider } from './context/SettingsContext'
import { AuthProvider } from './context/AuthContext'
import { AccountProvider } from './context/AccountContext'

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <Routes>
          {/* Public routes — no layout, no auth required */}
          <Route path="/login"         element={<Login />} />
          <Route path="/auth/callback" element={<OAuthCallback />} />

          {/* All other routes require authentication */}
          <Route path="*" element={
            <ProtectedRoute>
              <AccountProvider>
                <Layout>
                  <Routes>
                    <Route path="/"          element={<Home />} />
                    {/* 2026-09-09 fix: the sidebar's "DASHBOARD" nav item and every
                        other page's back-link imply this URL exists -- it never
                        matched anything, so a direct visit (bookmark, typed URL,
                        this exact review) rendered a blank content area with no
                        error at all (the outer catch-all route still matched and
                        drew the header/sidebar, just nothing inside). Alias, not
                        a rename -- "/" stays the canonical path other links use. */}
                    <Route path="/dashboard" element={<Home />} />
                    <Route path="/analysis"  element={<Analysis />} />
                    <Route path="/portfolio" element={<Portfolio />} />
                    <Route path="/positions" element={<Positions />} />
                    <Route path="/trades"    element={<Trades />} />
                    <Route path="/data"      element={<DataManagement />} />
                    <Route path="/watchlist" element={<Watchlist />} />
                    <Route path="/discovery" element={<Discovery />} />
                    <Route path="/gates"       element={<LogicGates />} />
                    <Route path="/performance" element={<Performance />} />
                    <Route path="/testing"   element={<Testing />} />
                    <Route path="/joshskills" element={<JoshSkills />} />
                    <Route path="/tools"     element={<Tools />} />   {/* T-381 */}
                    <Route path="/skills"    element={<Navigate to="/joshskills" replace />} />   {/* T-351: old link */}
                    <Route path="/trading-monitor" element={<TradingMonitor />} />
                    <Route path="/edge" element={<EdgeDiagnostics />} />
                    <Route path="/watchers"  element={<Watchers />} />
                    <Route path="/models"    element={<ModelDesk />} />
                    <Route path="/settings"  element={<Settings />} />
                    {/* Defensive fallback -- any other unmatched path (typo, stale
                        bookmark, a future removed route) now redirects home instead
                        of silently rendering nothing, the same failure mode as
                        above. */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Layout>
              </AccountProvider>
            </ProtectedRoute>
          } />
        </Routes>
      </SettingsProvider>
    </AuthProvider>
  )
}

export default App
